"use client"
/* */
const loadingSpinner = "flow--loading-spinner";
const styles = {
	loadingSpinner: loadingSpinner};

export { styles as default, loadingSpinner };
//# sourceMappingURL=LoadingSpinner.module.scss.mjs.map
